module.exports = __webpack_public_path__ + "img/vue2-lacet_rose.46a8be7a.png";